export const MAX_MESSAGE_LENGTH = 1600;
export const MAX_MESSAGE_RING_CENTRAL_LENGTH = 1000;
